import React from "react";

import Logo from "../../../assets/images/BlackLogo.svg";
import "./styles.css";

const SnetSvgLogo = () => {
  return <img src={Logo} alt="SingularityNET" loading="lazy" />;
};

export default SnetSvgLogo;
